import { ExportType } from 'shared/constants/export';
import { Conversation } from 'shared/interfaces/Conversation';

export interface Evaluation {
  _id: string;
  organisation: string;
  name: string;
  smartAssistant: string;
  evaluationTests: EvaluationTest[];
  evaluators: Evaluator[];
  createdAt: Date;
  updatedAt: Date;
}

export enum EvaluationTestInputType {
  SINGLE_STEP = 'SINGLE_STEP'
}

export enum EvaluationTestStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface SingleStepEvaluationTestInput {
  content: string;
}

export interface EvaluationTestInput {
  type: EvaluationTestInputType;
  singleStepTestInput: SingleStepEvaluationTestInput;
}

export interface EvaluatorJudgement {
  content: string;
  reason: string;
}

export interface EvaluationTestResult {
  conversation?: Conversation;
  judgements: EvaluatorJudgement[];
  lastRanAt: Date;
}

export interface EvaluationTest {
  _id: string;
  status: EvaluationTestStatus;
  input: EvaluationTestInput;
  result?: EvaluationTestResult;
}

export interface Evaluator {
  type: string;
}

export interface CreateEvaluationDto {
  smartAssistantId: string;
  name: string;
  singleStepQuestions: string[];
}

export interface RunEvaluationDto {
  evaluationTestIds: string[];
}

export interface EvalsGenerateSingleStepQuestionsDto {
  smartAssistantId: string;
  scenarios: string[];
  numberOfQuestions: number;
}

export interface EvalsGenerateSingleStepQuestionsResponseDto {
  singleStepQuestions: string[];
}

export interface ExportEvaluationDto {
  exportType: ExportType;
  locale: string;
  timezoneOffsetMs: number;
}

export interface ExportEvaluationDtoWithSmartAssistantId extends ExportEvaluationDto {
  smartAssistantId: string;
}
